import useAuthStore from '../AuthStore';

const setRedirect = (redirect: string) => useAuthStore.setState({ redirect });

export default setRedirect;
